import { CUSTOMERS, STATUSES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

const multipart =
  typeof FormData !== 'undefined'
    ? { headers: { 'Content-Type': 'multipart/form-data' } }
    : {};

export const customersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getCustomersList: build.query({
      query: (params = {}) => ({ url: CUSTOMERS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Customer', result),
    }),
    getCustomerById: build.query({
      query: (id) => ({ url: CUSTOMERS.BY_ID(id), method: 'GET' }),
      providesTags: (_r, _e, id) => [{ type: 'Customer', id }],
    }),
    createCustomer: build.mutation({
      query: (payload) => {
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: CUSTOMERS.LIST,
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: [{ type: 'Customer', id: 'LIST' }],
    }),
    updateCustomer: build.mutation({
      query: ({ id, data: updateData, ...rest }) => {
        const payload = updateData ?? rest;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: CUSTOMERS.BY_ID(id),
          method: 'POST',
          data: payload,
          ...(isFormData ? multipart : {}),
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Customer', id },
        { type: 'Customer', id: 'LIST' },
      ],
    }),
    deleteCustomer: build.mutation({
      query: (id) => ({ url: CUSTOMERS.BY_ID(id), method: 'DELETE' }),
      invalidatesTags: (_r, _e, id) => [
        { type: 'Customer', id },
        { type: 'Customer', id: 'LIST' },
      ],
    }),
    getCustomerStatus: build.query({
      query: () => ({
        url: STATUSES.LIST,
        method: 'GET',
        params: { 'conditions[model]': 'Customer' },
      }),
      providesTags: [{ type: 'Status', id: 'CUSTOMER' }],
    }),
  }),
});

export const {
  useGetCustomersListQuery,
  useLazyGetCustomersListQuery,
  useGetCustomerByIdQuery,
  useLazyGetCustomerByIdQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useDeleteCustomerMutation,
  useGetCustomerStatusQuery,
  useLazyGetCustomerStatusQuery,
} = customersApi;
